/* Tidies the Primy form on the contact page without moving any of Primy's elements
   (moving them made Primy re-render a second copy of the form):
   - hides Primy's own title + intro text
   - if more than one copy of the form ends up in the quote card, hides the extras */
(function () {
  var INTRO = /please fill out the form below/i;
  var TITLE = /^\s*(contact form|my new form)\s*$/i;

  function run() {
    var embeds = document.querySelectorAll('.contact-hero__form .form-embed');
    for (var e = 0; e < embeds.length; e++) {
      var embed = embeds[e];
      var els = embed.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div,legend');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.children.length) continue;
        var t = (el.textContent || '').trim();
        if (INTRO.test(t) || TITLE.test(t)) el.style.display = 'none';
      }
      var forms = embed.querySelectorAll('form');
      for (var f = 1; f < forms.length; f++) forms[f].style.display = 'none';
    }
  }

  var timer;
  var obs = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 150); });
  function start() { run(); obs.observe(document.body, { childList: true, subtree: true }); setTimeout(function () { obs.disconnect(); }, 20000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
